<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <div class="row">
            <div class="col-9">
              <h4 class="text-green d-inline-block m-0 align-middle">
                選擇撥入對象
              </h4>
              <div class="tags d-inline-block">
                <div class="tag" key="dialin-tag">
                  {{ RouterPara.managerTabOne.dialInName }}
                  {{ RouterPara.managerTabOne.dialInCode }}
                </div>
              </div>
            </div>
            <div class="col-3 text-right">
              <span class="text label"
                >已選：{{ this.computedCount.householdCount }}戶 /
                {{ this.computedCount.ceapcnoCount }}件</span
              >
            </div>
            <div
              v-if="RouterPara.managerTabOne.condictions.type == '6'"
              class="col-3"
            >
              <h4 class="text-green d-inline-block m-0 align-middle">
                單日上限 :
              </h4>

              <!-- 列表模式 type 6 數量計算 -->
              <div v-if="!mapMode" class="d-inline-block">
                <span class="text text-red"
                  >{{ limitCount + Number(originalCount) }}/50</span
                >
              </div>

              <!-- 地圖模式 type 6 數量計算 -->
              <div v-else class="d-inline-block">
                <span class="text text-red"
                  >{{ Number(originalCount) + selectedMarker.length }}/50</span
                >
              </div>
            </div>
          </div>
        </div>
        <hr />
        <form class="form">
          <div class="container" v-if="!mapMode">
            <div class="row" :class="{ 'section-loading': isInsertApiLoading }">
              <div class="col-12">
                <h4 class="text-green mt-0">整合篩選</h4>
              </div>
              <div class="col-5">
                <div class="form-group row">
                  <label for="client-name" class="col-3 text-right"
                    >客戶姓名</label
                  >
                  <div class="col-6">
                    <input
                      type="text"
                      v-model="inteSelect.clientName"
                      id="client-name"
                      class="form-control"
                      alt="ch"
                    />
                  </div>
                </div>
              </div>
              <div class="col-7">
                <div class="form-group row">
                  <label for="charger" class="col-3 text-right">收費人員</label>
                  <div class="col-3">
                    <select
                      name=""
                      id=""
                      v-model="inteSelect.charger[0]"
                      class="form-control"
                    >
                      <option value="">請選擇</option>
                      <option value="now">現行人員</option>
                      <option value="past">前一人員</option>
                    </select>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      :disabled="chargerDisable"
                      alt="ch"
                      v-model="inteSelect.charger[1]"
                      class="form-control"
                      placeholder="請輸入姓名"
                    />
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="form-group row">
                  <label for="custVip" class="col-3 text-right">VIP</label>
                  <div class="col-6">
                    <select
                      name=""
                      v-model="inteSelect.vip"
                      id="custVip"
                      class="form-control"
                    >
                      <option value="">請選擇</option>
                      <option value="G">黃金</option>
                      <option value="P">白金</option>
                      <option value="D">鑽石</option>
                      <option value="S">密戶</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-7">
                <div class="form-group row">
                  <label for="self" class="col-3 text-right">自招</label>
                  <div class="col-6">
                    <select
                      v-model="inteSelect.self"
                      id="self"
                      class="form-control"
                    >
                      <option value="">請選擇</option>
                      <option value="1">自招</option>
                      <option value="0">非自招</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="form-group row">
                  <label for="" class="col-3 text-right">整合地址</label>
                  <div class="col-4">
                    <select
                      @change="queryDist"
                      v-model="inteSelect.address[0]"
                      class="form-control"
                    >
                      <option value="">縣市</option>
                      <option
                        v-for="(item, index) in cityList"
                        :key="`city-${index}`"
                        :value="item.city"
                        >{{ item.city }}</option
                      >
                    </select>
                  </div>
                  <div class="col-5">
                    <select
                      :disabled="distDisable"
                      v-model="inteSelect.address[1]"
                      class="form-control"
                    >
                      <option value="">鄉鎮市區</option>
                      <option
                        v-for="(item, index) in distLsit"
                        :key="`dist-${index}`"
                        :value="item.AREA"
                        >{{ item.AREA }}</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <input
                  type="text"
                  :disabled="addressDisable"
                  v-model="inteSelect.address[2]"
                  class="form-control"
                  placeholder="路段名稱"
                  alt="ch"
                />
              </div>
              <div class="col-3 text-right">
                <button
                  type="button"
                  class="btn btn-primary m-0"
                  @click="listFilter"
                >
                  篩選
                </button>
              </div>
            </div>

            <section class="insurance-table newTable">
              <div :class="{ 'section-loading': isInsertApiLoading }">
                <table class="table datatable table-striped table-bordered">
                  <thead>
                    <tr>
                      <th width="60">
                        <div class="checkbox checkbox-inline mr-0">
                          <input
                            type="checkbox"
                            :name="`check-all`"
                            :id="`check-all`"
                            v-model="checkAll"
                            @click="checkAllClick = true"
                          />
                          <label :for="`check-all`"></label>
                        </div>
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceplcno'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceplcno')"
                      >
                        保單號碼
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceapcnm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceapcnm')"
                      >
                        客戶姓名
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceclcno'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceclcno')"
                      >
                        現行收<br />費人員
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceagent'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceagent')"
                      >
                        自招件
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'd2_payaddr'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('d2_payaddr')"
                      >
                        整合地址
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'celpscs_nm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('celpscs_nm')"
                      >
                        契約<br />效力
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceclcnm_old'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceclcnm_old')"
                      >
                        前一收<br />費人員
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'intr_name'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('intr_name')"
                      >
                        增員者
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'ceagnnm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('ceagnnm')"
                      >
                        經手人
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'other_ceclcnm'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('other_ceclcnm')"
                      >
                        其他收<br />費人員
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'cenxpdt'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('cenxpdt')"
                      >
                        下次<br />應繳日
                      </th>
                      <th
                        :class="
                          'sorting ' +
                            (order.fieldName == 'deadline'
                              ? order.asc
                                ? 'sorting_asc'
                                : 'sorting_desc'
                              : '')
                        "
                        @click="processSearchResult('deadline')"
                      >
                        調撥<br />截止日
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="searchResult.length && !listLoading">
                    <tr
                      v-for="(item, index) in searchResult"
                      :key="`result-table-${index}-${item.ceplcno}`"
                    >
                      <td>
                        <div class="mr-0 checkbox checkbox-inline">
                          <input
                            type="checkbox"
                            :name="`result-table-td-item`"
                            :id="`result-table-${index}`"
                            v-model="resultSelection"
                            @click="checkAllClick = false"
                            @change="updateSelected(item, index)"
                            :value="index"
                          />
                          <label :for="`result-table-${index}`"></label>
                        </div>
                      </td>
                      <td width="125px">{{ item.ceplcno }}</td>
                      <td width="100px">
                        <span>
                          <span
                            class="d-inline-block text-center align-middle mr-1"
                          >
                            <level :lv="Number(item.vip)" /><br />
                            <avatar
                              :gender="Number(item.ceapcno[1])"
                              :size="20"
                            />
                          </span>
                          <span class="name align-middle">
                            {{ item.ceapcnm }}
                          </span>
                        </span>
                      </td>
                      <td width="100px">
                        {{ item.ceclcnm }}<br />{{ item.ceclcno }}
                      </td>
                      <td width="40px">{{ item.ceagent > 0 ? "是" : "否" }}</td>
                      <td width="120px">
                        {{ item.zip_code ? item.zip_code : ""
                        }}{{ item.d2_payaddr }}
                      </td>
                      <td>{{ item.celpscs_nm }}</td>
                      <td width="95px">
                        {{ item.ceclcnm_old ? item.ceclcnm_old : "" }}<br />{{
                          item.ceclcno_old ? item.ceclcno_old : ""
                        }}
                      </td>
                      <td width="80px">
                        {{ item.intr_name ? item.intr_name : "" }}
                      </td>
                      <td width="80px">
                        {{ item.ceagnnm ? item.ceagnnm : "" }}
                      </td>
                      <td width="100px">
                        {{ item.other_ceclcnm ? item.other_ceclcnm : ""
                        }}<br />{{
                          item.other_ceclcno ? item.other_ceclcno : ""
                        }}
                      </td>
                      <td width="105px">{{ item.cenxpdt | dateFormat }}</td>
                      <td width="105px">{{ item.deadline | dateFormat }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="10" class="empty-block bg-white">
                        <h3 v-if="!listLoading" class="bg-white">查無資料</h3>
                        <h3 v-else class="bg-white">
                          <div
                            class="section-loading d-inline-block"
                            style="height:20px; width:30px"
                          ></div>
                          資料讀取中...
                        </h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div class="container" v-else>
            <div class="row" :class="{ 'section-loading': isInsertApiLoading }">
              <div class="col-12">
                <h4 class="text-green mt-0">地圖篩選</h4>
              </div>
              <div class="col-5">
                <div class="form-group row">
                  <label for="client-name" class="col-3 text-right"
                    >客戶姓名</label
                  >
                  <div class="col-6">
                    <input
                      type="text"
                      v-model="mapSelect.clientName"
                      id="client-name"
                      class="form-control"
                      alt="ch"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12"></div>
              <div class="col-5">
                <div class="form-group row">
                  <label for="" class="col-3 text-right">整合地址</label>
                  <div class="col-4">
                    <select
                      @change="queryDistForMap"
                      v-model="mapSelect.address[0]"
                      class="form-control"
                    >
                      <option value="">縣市</option>
                      <option
                        v-for="(item, index) in cityList"
                        :key="`city-${index}`"
                        :value="item.city"
                        >{{ item.city }}</option
                      >
                    </select>
                  </div>
                  <div class="col-5">
                    <select
                      v-model="mapSelect.address[1]"
                      :disabled="distDisableMap"
                      class="form-control"
                    >
                      <option value="">鄉鎮市區</option>
                      <option
                        v-for="(item, index) in distLsitForMap"
                        :key="`dist-${index}`"
                        :value="item.AREA"
                        >{{ item.AREA }}</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <input
                  type="text"
                  v-model="mapSelect.address[2]"
                  :disabled="addressDisableMap"
                  class="form-control"
                  placeholder="路段名稱"
                />
              </div>
              <div class="col-3 text-right">
                <button
                  type="button"
                  class="btn btn-primary m-0"
                  @click="mapListFilter"
                  alt="ch"
                >
                  篩選
                </button>
              </div>
              <div class="col-12 text-right">
                <div class="radio radio-inline">
                  <input
                    type="radio"
                    v-model="mapRadioValue"
                    id="map-select-type-1"
                    name="map-select-type"
                    value="1"
                  />
                  <label for="map-select-type-1">圓形選取</label>
                </div>
                <div class="radio radio-inline">
                  <input
                    type="radio"
                    v-model="mapRadioValue"
                    id="map-select-type-2"
                    name="map-select-type"
                    value="2"
                  />
                  <label for="map-select-type-2">方形選取</label>
                </div>
              </div>
            </div>
            <div v-if="mapLoading" id="gmap" class="section-loading"></div>
            <div
              v-else
              id="gmap"
              :class="{ 'section-loading': isInsertApiLoading }"
            >
              <GmapMap
                :center="center"
                :zoom="zoom"
                style="width: 100%; height: 100%;"
                @dragend="dragend"
                @center_changed="updateMapCenter($event)"
              >
                <!-- 針對難字下 v-if="!infoWin.ceapcnm == ''" 判斷 -->
                <GmapInfoWindow
                  v-show="!infoWin.ceapcnm == ''"
                  :options="infoWin.options"
                  :position="infoWin.pos"
                  :opened="infoWin.open"
                  @closeclick="infoWin.open = false"
                >
                  <p>要　保　人：{{ infoWin.ceapcnm }}</p>
                  <p>地　　　址：{{ infoWin.d2_payaddr }}</p>
                  <p>服 務 人 員：{{ infoWin.ceclcnm }}</p>
                  <div class="text-center">
                    <a class="btn btn-default" @click.prevent="closeWindow"
                      >取消</a
                    >
                    <a class="btn btn-red" @click.prevent="checkRemoveMarker"
                      >移除調撥</a
                    >
                  </div>
                </GmapInfoWindow>
                <GmapMarker
                  v-for="(m, index) in markers"
                  :key="index"
                  :position="m.position"
                  :animation="4"
                  :clickable="true"
                  :draggable="false"
                  @click="toggleInfoWindow(m, index)"
                />
                <gmap-circle
                  v-if="mapDrawType === `circle`"
                  ref="circle"
                  :radius="radius"
                  :center="mapCenter"
                  :draggable="false"
                  :editable="true"
                  :options="{ fillColor: '#e3e7ff', fillOpacity: 0.5 }"
                  @radius_changed="radiusChanged($event)"
                  @center_changed="center_changed($event)"
                >
                </gmap-circle>
                <gmap-rectangle
                  v-if="mapDrawType === `rectangle`"
                  :bounds="rectangleBounds"
                  :options="{
                    editable: true,
                    draggable: false,
                    fillColor: '#e3e7ff',
                    fillOpacity: 0.5
                  }"
                  @bounds_changed="rectangleChanged($event)"
                >
                </gmap-rectangle>
              </GmapMap>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-6">
                <!--<a class="btn btn-default" @click="toggleMode">
                  <span v-if="!mapMode">檢視地圖模式</span>
                  <span v-else>返回列表模式</span>
                </a>-->
              </div>
              <div class="col-6 text-right">
                <!--<router-link :to="UserRight.SUPERVISOR_AREA_01 ? '/manager/tab/1' : '/submanager/tab/1'" class="btn btn-default">
                        上一步
                    </router-link>-->
                <router-link
                  v-if="
                    this.$store.state.userInfo.roleId == 'SALES_MANAGER_02' ||
                      (this.$store.state.userInfo.roleId ==
                        'SALES_MANAGER_06' &&
                        this.$store.state.userInfo.functionId &&
                        this.$store.state.userInfo.functionId.includes('3'))
                  "
                  :to="'/manager/tab/1'"
                  class="btn btn-default"
                >
                  上一步
                </router-link>
                <router-link
                  v-else
                  :to="'/submanager/tab/1'"
                  class="btn btn-default"
                >
                  上一步
                </router-link>
                <a class="btn btn-primary" @click="doConfirm()">
                  下一步
                </a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <warning-modal
      :open="warnModalOpen"
      :message="warnModalMsg"
      :showCancel="warnCancelShow"
      :buttonDisabled="buttonDisabled"
      :confirmText="confirmText"
      @submit="doSubmitMethod"
      @close="panelClose('warnModalOpen')"
    />
    <count-warning-modal
      :open="countModalOpen"
      :message="countModalMsg"
      @close="panelClose('countModalOpen')"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import DialOutPersonModal from "@/desktop/components/manager/DialOutPersonModal";
import DialInPersonModal from "@/desktop/components/manager/DialInPersonModal";
import TabHeader from "@/desktop/components/manager/TabHeader";
import WarningModal from "@/desktop/components/WarningModal";
import CountWarningModal from "@/desktop/components/CountWarningModal";
import Avatar from "@/components/Avatar";
import Level from "@/components/Level";
import { debuglog, log } from "util";
import {
  queryAllocationList,
  queryDistByCity,
  getGoogleMapLocation,
  insertServiceRecord,
  queryDivLatLnt
} from "@/service";

export default {
  name: "TransferTab1Filter",
  mixins: [commonMixin],
  components: {
    TabHeader,
    DialOutPersonModal,
    DialInPersonModal,
    WarningModal,
    CountWarningModal,
    Level,
    Avatar
  },
  computed: {
    ...mapGetters(["Cities", "RouterPara", "UserRight"]),
    // 計算列表模式 type 6 件數
    limitCount() {
      //過濾重覆id計算當日上限
      let nolyOneId = [];
      let filterAry = this.searchResult.filter((item, index) => {
        return this.resultSelection.includes(index);
      });
      filterAry.forEach(item => {
        if (!nolyOneId.includes(item.ceapcno)) {
          nolyOneId.push(item.ceapcno);
        }
      });
      return nolyOneId.length;
    },
    // 監聽相關欄位 Disable
    chargerDisable() {
      return this.inteSelect.charger[0] == "";
    },
    distDisable() {
      return this.inteSelect.address[0] == "";
    },
    addressDisable() {
      return this.inteSelect.address[1] == "";
    },
    distDisableMap() {
      return this.mapSelect.address[0] == "";
    },
    addressDisableMap() {
      return this.mapSelect.address[1] == "";
    },
    // 計算件數/戶數(戶數是客戶id數、件數是保單ID)
    computedCount() {
      var ceapcnoList = [];
      if (!this.mapMode) {
        this.searchResult.forEach((item, index) => {
          if (this.resultSelection.includes(index)) {
            ceapcnoList.push(item.ceapcno);
          }
        });
      } else {
        this.searchResult.forEach((item, index) => {
          if (
            this.selectedMarker.filter(s => s.ceapcno === item.ceapcno).length >
            0
          ) {
            ceapcnoList.push(item.ceapcno);
          }
        });
      }
      return {
        ceapcnoCount: ceapcnoList.length,
        householdCount: [...new Set(ceapcnoList)].length
      };
    }
  },
  data() {
    return {
      mapMode: false,
      isInsertApiLoading: false,
      inAgentInfo: {},
      warnModalOpen: false,
      countModalOpen: false,
      countModalMsg: "",
      countCancelShow: false,
      checkAllClick: false,
      listLoading: false,
      warnModalMsg: "",
      resultSelection: [],
      mapLoading: true,
      originalCount: "",
      checkType: false,
      warnCancelShow: true,
      warnMethodName: "",
      buttonDisabled: false,
      confirmText: "確定",
      center: {
        lat: 22.635715,
        lng: 120.336122
      },
      infoWin: {
        options: {
          pixelOffset: {
            width: 0,
            height: -45
          },
          disableAutoPan: true
        },
        pos: null,
        open: false,
        ceapcnm: "",
        d2_payaddr: "",
        ceclcnm: "",
        markerIndex: 0
      },
      currentMidx: null,
      unfilteredMarkers: [],
      originMarkers: [],
      markers: [],
      cityList: [],
      distLsit: [],
      distLsitForMap: [],
      originResult: [],
      inteSelect: {
        clientName: "",
        charger: ["", ""],
        vip: "",
        self: "",
        address: ["", "", ""]
      },
      mapSelect: {
        clientName: "",
        address: ["", "", ""]
      },
      form: {
        dialOut: [],
        dialIn: [],
        selected: []
      },
      nameList: [],
      countList: [],
      checkAll: false,
      searchResult: [],
      condictions: {
        cedvno3: "",
        type: "",
        clcno_old: "",
        ceplcno: "",
        ceapcno: "",
        zip: "",
        addr: "",
        segment_old: "",
        clcno_old_list: "",
        clcno_new: "",
        cusname: "",
        now_ex: "",
        ceclcnm: "",
        is_vip: "",
        ceagent: "",
        zip_filter: "",
        addr_filter: "",
        selected_plcno: ""
      },
      order: {
        fieldName: "",
        asc: true
      },
      zoom: 13,
      zoomFactor: 0.03,
      selectedMarker: [], // 被圈選中的釘子
      mapRadioValue: "1",
      mapDrawType: "circle",
      mapCenter: {
        lat: 22.635715,
        lng: 120.336122
      },
      circleCenter: {}, // 圓形座標點
      radius: 3500, // 圓型預設半徑
      rectangleValue: undefined, // 方形座標點
      rectangle: {}, // 方形座標點
      rectangleBounds: {
        // 方形預設座標
        north: 33.685,
        south: 50.671,
        east: -70.234,
        west: -116.251
      },
      fromPath: '' //前一個頁面路由的路徑
    };
  },
  watch: {
    mapMode() {
      // 切換模式時關閉資訊視窗
      this.infoWin.open = false;
    },
    checkAll(val) {
      this.doAll(val);
    },
    mapRadioValue(val) {
      if (val === `1`) {
        // 切換為圓圈模式
        this.mapDrawType = "circle";
        this.circleCenter.lat = this.mapCenter.lat;
        this.circleCenter.lng = this.mapCenter.lng;
        this.checkInCircle();
      } else if (val === `2`) {
        // 切換為方形模式
        this.mapDrawType = "rectangle";
        console.log("++++ " + this.zoomFactor);
        // 重設方形範圍
        this.rectangle = new google.maps.Polygon({
          paths: [
            {
              lat: this.mapCenter.lat + this.zoomFactor,
              lng: this.mapCenter.lng + this.zoomFactor
            },
            {
              lat: this.mapCenter.lat + this.zoomFactor,
              lng: this.mapCenter.lng - this.zoomFactor
            },
            {
              lat: this.mapCenter.lat - this.zoomFactor,
              lng: this.mapCenter.lng - this.zoomFactor
            },
            {
              lat: this.mapCenter.lat - this.zoomFactor,
              lng: this.mapCenter.lng + this.zoomFactor
            }
          ]
        });

        this.rectangleBounds = {
          north: this.mapCenter.lat + this.zoomFactor,
          south: this.mapCenter.lat - this.zoomFactor,
          east: this.mapCenter.lng + this.zoomFactor,
          west: this.mapCenter.lng - this.zoomFactor
        };

        this.rectangleValue = undefined;
        this.checkInRectangle();
      }
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    doAll(val) {
      // 跟 selected 連動
      if (val && this.checkAllClick) {
        this.resultSelection = [];
        this.searchResult.forEach((data, index) => {
          this.resultSelection.push(index);
        });
        this.checkIdmarkType(this.searchResult);
        this.checkType = true;
      } else if (this.checkAllClick) {
        this.resultSelection = [];
      }
    },
    updateSelected(custData, clickIndex) {
      const selectedHasVal = this.resultSelection.includes(clickIndex);
      if (selectedHasVal) {
        // 選取陣列已有該客戶ID
        this.checkIdmarkType(custData);
        this.checkType = true;
        this.searchResult.forEach((item, index) => {
          // 連動服務件列表客戶 ID
          if (!this.resultSelection.includes(index)) {
            if (custData.ceapcno === item.ceapcno) {
              // 連動新增
              this.resultSelection.push(index);
            }
          }
        });
      } else {
        // 選取陣列無該客戶ID
        this.checkType = false;
        this.searchResult.forEach((item, index) => {
          // 連動刪除
          if (custData.ceapcno === item.ceapcno) {
            this.resultSelection = this.resultSelection.filter(item => {
              return item !== index;
            });
          }
        });
      }

      // 跟 checkAll 連動
      if (
        this.searchResult.length !== this.resultSelection.length &&
        !this.checkAllClick
      ) {
        this.checkAll = false;
      } else if (!this.checkAllClick) {
        this.checkAll = true;
      }
    },
    checkIdmarkType(val) {
      //判斷idmark是否為密戶
      if (this.resultSelection.length == val.length) {
        let isScr = false;
        this.nameList = [];
        const set = new Set();
        let idByList = [];
        idByList = val.filter(item =>
          !set.has(item.ceapcno) ? set.add(item.ceapcno) : false
        ); // 過濾重覆ID
        idByList.forEach((item, index) => {
          if (item.idmark.includes("S")) {
            this.nameList.push(item.ceapcnm);
            isScr = true;
          }
        });
        if (isScr) {
          // this.setToastMsg(`保戶${this.nameList}為「密戶」，請再確認是否要更換服務人員`)
          this.warnModalMsg = `保戶${this.nameList}為「密戶」，請再確認是否要更換服務人員`;
          this.warnMethodName = "removeMarker";
          this.warnCancelShow = false;
          this.panelOpen("warnModalOpen");
        }
      } else if (
        this.resultSelection.length != val.length &&
        val.idmark.indexOf("S") >= 0
      ) {
        // this.setToastMsg(`保戶${val.ceapcnm}為「密戶」，請再確認是否要更換服務人員`)
        this.warnModalMsg = `保戶${val.ceapcnm}為「密戶」，請再確認是否要更換服務人員`;
        this.warnMethodName = "removeMarker";
        this.warnCancelShow = false;
        this.panelOpen("warnModalOpen");
      }
    },
    removeMarker() {
      // 移除 marker info
      this.panelClose("warnModalOpen");
      this.markers.splice(this.infoWin.markerIndex, 1);
      this.infoWin.open = !this.infoWin.open;
      this.checkIn();
    },
    closeWindow() {
      // 關閉 marker info
      this.infoWin.open = !this.infoWin.open;
    },
    toggleInfoWindow(marker, idx) {
      // 切換 marker info 並更新資訊
      this.infoWin.pos = marker.position; // 設定視窗位置

      // for 難字 update
      this.infoWin.ceapcnm = ""; // 設定要　保　人
      this.infoWin.d2_payaddr = ""; // 設定地　　　址
      this.infoWin.ceclcnm = ""; // 設定服 務 人 員

      setTimeout(() => {
        this.infoWin.ceapcnm = marker.ceapcnm; // 設定要　保　人
        this.infoWin.d2_payaddr = marker.d2_payaddr; // 設定地　　　址
        this.infoWin.ceclcnm = marker.ceclcnm; // 設定服 務 人 員
        this.registerHanlink();
      }, 100);

      this.infoWin.markerIndex = idx;
      if (this.currentMidx == idx) {
        this.infoWin.open = !this.infoWin.open;
      } else {
        this.infoWin.open = true;
        this.currentMidx = idx;
      }
    },
    toggleMode() {
      // 切換模式
      if (!this.mapMode) {
        // 列表 >> 地圖
        let formData = {};
        let selectedAry = this.searchResult
          .filter((itemObj, index) => {
            // 過濾已選擇的客戶資料
            return this.resultSelection.includes(index);
          })
          .map(itemNum => {
            // 過濾物件成保單號碼
            return itemNum.ceplcno;
          });
        formData = {
          ...this.RouterPara.managerTabOne.condictions, // 解構賦值 調撥首頁選擇的參數
          ...this.inteSelect, // 解構賦值 inteSelect 物件
          selected_plcno: selectedAry
        };

        // 調撥首頁選擇的參數支持手動輸入多筆保單號碼(無撥出對象且列表無選擇客戶)
        if (!formData.clcno_old && selectedAry.length == 0) {
          delete formData.selectedPlcno;
          formData.selected_plcno = this.RouterPara.managerTabOne.condictions.selectedPlcno;
        }

        this.mapMode = true;
        this.mapLoading = true;
        this.registerHanlink(); // for 難字輸入
        getGoogleMapLocation(this.$store.state.userInfo.id, formData).then(
          result => {
            this.mapLoading = false;
            if (result && result.header && result.header.status === "200") {
              let rtnList = result.body.policy_list;
              if (rtnList) {
                // 判斷是否有 body.policy_list
                // seting marker 並濾掉重複地址
                let filterAddr = [];
                let filterIndex = [];
                rtnList.forEach((element, index, arr) => {
                  if (!filterAddr.includes(element.d2_payaddr)) {
                    filterAddr.push(element.d2_payaddr);
                    filterIndex.push(index);
                  }
                });
                this.unfilteredMarkers = rtnList; //尚未過濾重複地址的資料
                this.originMarkers = rtnList
                  .filter((item, index) => {
                    return filterIndex.includes(index);
                  })
                  .map(site => {
                    return {
                      position: {
                        lat: site.latitude || "",
                        lng: site.longitude || ""
                      },
                      ...site
                    };
                  })
                  .filter(site => {
                    return site.position.lat != "";
                  });

                this.markers = [...this.originMarkers]; //參照原始資料
              } else {
                this.markers = [];
              }

              // 設定地圖中心
              queryDivLatLnt(
                this.$store.state.userInfo.id,
                this.$store.state.userInfo.divNo
              ).then(resp => {
                if (
                  resp &&
                  resp.header &&
                  resp.header.status === "200" &&
                  resp.body &&
                  resp.body.latitude &&
                  resp.body.longitude
                ) {
                  // 有取得單位經緯度
                  this.center = {
                    lat: resp.body.latitude,
                    lng: resp.body.longitude
                  };
                } else {
                  // 無取得單位經緯度，使用客戶平均經緯度
                  if (this.markers.length > 0) {
                    // 加總經緯度
                    let averageLat = 0;
                    let averageLng = 0;
                    this.markers.forEach(item => {
                      averageLat = averageLat + item.position.lat;
                      averageLng = averageLng + item.position.lng;
                    });

                    // 平均總經緯度
                    averageLat = averageLat / this.markers.length;
                    averageLng = averageLng / this.markers.length;

                    // 設定中心點
                    if (Number.isNaN(averageLat) || Number.isNaN(averageLng)) {
                      this.center = {
                        lat: 22.635715,
                        lng: 120.336122
                      };
                    } else {
                      this.center = {
                        lat: averageLat.toFixed(6) - 0,
                        lng: averageLng.toFixed(6) - 0
                      };
                    }
                  } else {
                    this.center = {
                      lat: 22.635715,
                      lng: 120.336122
                    };
                  }
                }

                // 設定地圖中心點
                this.mapCenter.lat = this.center.lat;
                this.mapCenter.lng = this.center.lng;

                // 設定圓形預設
                this.circleCenter.lat = this.center.lat;
                this.circleCenter.lng = this.center.lng;

                // 設定方形
                this.rectangleBounds = {
                  north: this.center.lat + this.zoomFactor,
                  south: this.center.lat - this.zoomFactor,
                  east: this.center.lng + this.zoomFactor,
                  west: this.center.lng - this.zoomFactor
                };

                // 設定為圓形選取
                this.mapRadioValue = "1";

                // 檢查範圍
                setTimeout(() => {
                  this.checkInCircle();
                }, 500);
              });
            } else {
              this.$toast.info({ title: result.header.message });
              console.error("查詢服務件地圖列表 API 錯誤");
            }
          }
        );
      } else {
        // 地圖 >> 列表
        let toInsNoList = this.selectedMarker
          .map(item => {
            // 過濾出不重複 ID
            return item.ceapcno;
          })
          .filter((element, index, arr) => {
            return arr.indexOf(element) === index;
          });
        let listIndex = [];
        this.searchResult.forEach((item, index) => {
          // 過濾出 index 陣列
          if (toInsNoList.includes(item.ceapcno)) {
            listIndex.push(index);
          }
        });
        this.resultSelection = listIndex; // 同步到客戶列表 checkBox

        this.mapMode = false;
      }
    },
    doSubmitMethod() {
      this[this.warnMethodName]();
    },
    checkRemoveMarker() {
      this.warnModalMsg = `確認要移除調撥 ${this.infoWin.ceapcnm}`;
      this.warnMethodName = "removeMarker";
      this.panelOpen("warnModalOpen");
    },
    doRemind(){
      if (
        this.$store.state.userInfo.roleId == "SALES_MANAGER_02" ||
        (this.$store.state.userInfo.roleId == "SALES_MANAGER_06" &&
          this.$store.state.userInfo.functionId &&
          this.$store.state.userInfo.functionId.includes("3"))
      ) {
        //  如果是大主管
        this.warnModalMsg = "【調撥申請已送出】";
      } else {
        //  如果是小主管
        this.warnModalMsg = "【小額調撥申請已送出，請通知單位主管覆核】";
      }
      
      this.warnMethodName = "doSubmit";
      this.warnCancelShow = false;
      this.panelOpen("warnModalOpen");
    },
    doSubmit() {
      // 下一步寫入紀錄
      // Call API
      if (this.buttonDisabled) {
        return;
      }

      this.buttonDisabled = true;
      this.confirmText = "處理中...";

      const typeCondition = this.RouterPara.managerTabOne.condictions.type;
      if (!this.mapMode) {
        // for 列表模式
        let policyList = this.searchResult.filter((item, index) => {
          // 過濾以選擇list
          return this.resultSelection.includes(index);
        });
        this.isInsertApiLoading = true;
        insertServiceRecord(
          this.$store.state.userInfo.id,
          typeCondition,
          policyList,
          this.inAgentInfo,
          this.RouterPara.managerTabOne.dialInCode,
          this.$store.state.userInfo.name
        ).then(result => {
          this.buttonDisabled = false;
          this.confirmText = "確定";

          if (result.header && result.header.status === "200") {
            this.$toast.info({ title: "服務件調撥已完成！" });
            if (
              this.$store.state.userInfo.roleId == "SALES_MANAGER_02" ||
              (this.$store.state.userInfo.roleId == "SALES_MANAGER_06" &&
                this.$store.state.userInfo.functionId &&
                this.$store.state.userInfo.functionId.includes("3"))
            ) {
              //  如果是大主管
              this.$router.push({ name: "transfer-tab1" });
            } else {
              //  如果是小主管
              this.$router.push({ name: "sub-transfer-tab-1" });
            }
          } else {
            if (result.header && result.header.message) {
              this.$toast.info({ title: result.header.message });
            } else {
              this.$toast.info({ title: "系統連線異常,請稍後再試" });
            }
          }
          this.isInsertApiLoading = false;
        });
      } else {
        // for 地圖模式
        let policyList = [];
        this.unfilteredMarkers.forEach(uf => {
          for (var i = 0; i < this.selectedMarker.length; i++) {
            if (uf.d2_payaddr == this.selectedMarker[i].d2_payaddr) {
              policyList.push(uf);
              break;
            }
          }
        });
        this.isInsertApiLoading = true;
        insertServiceRecord(
          this.$store.state.userInfo.id,
          typeCondition,
          policyList,
          this.inAgentInfo,
          this.RouterPara.managerTabOne.dialInCode,
          this.$store.state.userInfo.name
        ).then(result => {
          this.buttonDisabled = false;
          this.confirmText = "確定";

          if (result.header && result.header.status === "200") {
            this.$toast.info({ title: "服務件調撥已完成！" });
            if (
              this.$store.state.userInfo.roleId == "SALES_MANAGER_02" ||
              (this.$store.state.userInfo.roleId == "SALES_MANAGER_06" &&
                this.$store.state.userInfo.functionId &&
                this.$store.state.userInfo.functionId.includes("3"))
            ) {
              //  如果是大主管
              this.$router.push({ name: "transfer-tab1" });
            } else {
              //  如果是小主管
              this.$router.push({ name: "sub-transfer-tab-1" });
            }
          } else {
            if (result.header && result.header.message) {
              this.$toast.info({ title: result.header.message });
            } else {
              this.$toast.info({ title: "系統連線異常,請稍後再試" });
            }
          }
          this.isInsertApiLoading = false;
        });
      }

      this.panelClose("warnModalOpen");
    },
    doConfirm() {
      if (!this.mapMode) {
        // 列表模式
        // 確認是否有選擇客戶
        if (this.resultSelection.length == 0) {
          return this.$toast.info({ title: "請至少選擇一位客戶" });
        }

        // 如果是 condictions.type 為 6 時 每日調撥上限為50位客戶
        if (
          this.limitCount + Number(this.originalCount) > 50 &&
          this.RouterPara.managerTabOne.condictions.type == "6"
        ) {
          return this.setToastMsg(
            `每日調撥上限為50位客戶，您勾選的客戶人數已超過上限${this
              .limitCount +
              Number(this.originalCount) -
              50}位。`
          );
        }
      } else {
        // 地圖模式
        // 確認是否有選擇客戶
        if (this.selectedMarker.length == 0) {
          return this.$toast.info({ title: "請至少選擇一位客戶" });
        }

        // 如果是 condictions.type 為 6 時 每日調撥上限為50位客戶
        if (
          this.selectedMarker.length + Number(this.originalCount) > 50 &&
          this.RouterPara.managerTabOne.condictions.type == "6"
        ) {
          return this.setToastMsg(
            `每日調撥上限為50位客戶，您勾選的客戶人數已超過上限${this
              .selectedMarker.length +
              Number(this.originalCount) -
              50}位。`
          );
        }
      }

      this.warnModalMsg = "你是否確認要進行服務件調撥？";
      this.warnMethodName = "doRemind";
      this.warnCancelShow = true;
      this.panelOpen("warnModalOpen");
    },
    doCheckAll(val) {
      if (!val) this.form.selected = [];
      else
        this.searchResult.forEach(r => {
          this.form.selected.push(r.id);
        });
    },
    updateSelection(selection) {
      this.resultSelection = selection;
    },
    queryDist() {
      this.inteSelect.address[1] = "";
      this.inteSelect.address[2] = "";
      this.distLsit = [];
      if (this.inteSelect.address[0] == "") {
        return false;
      }
      queryDistByCity(
        this.$store.state.userInfo.id,
        this.inteSelect.address[0]
      ).then(distdata => {
        if (distdata && distdata.header && distdata.header.status === "200") {
          this.distLsit = distdata.body.cityAreaList;
        } else {
          console.error("取得鄉鎮市區失敗 method: queryDistByCity");
        }
      });
    },
    queryDistForMap() {
      this.mapSelect.address[1] = "";
      this.mapSelect.address[2] = "";
      this.distLsitForMap = [];
      if (this.mapSelect.address[0] == "") {
        return false;
      }
      queryDistByCity(
        this.$store.state.userInfo.id,
        this.mapSelect.address[0]
      ).then(distdata => {
        if (distdata && distdata.header && distdata.header.status === "200") {
          this.distLsitForMap = distdata.body.cityAreaList;
        } else {
          console.error("取得鄉鎮市區失敗 method: queryDistByCity");
        }
      });
    },
    mapListFilter() {
      // 地圖篩選過濾
      this.markers = [...this.originMarkers];
      this.infoWin.open = false;
      // 過濾客戶姓名  clientName
      if (this.mapSelect.clientName !== "") {
        this.markers = this.markers.filter(item => {
          return item.ceapcnm.includes(this.mapSelect.clientName);
        });
      }
      // 過濾整合地址  address
      if (this.mapSelect.address[0] !== "") {
        let allAddress =
          this.mapSelect.address[0] +
          this.mapSelect.address[1] +
          this.mapSelect.address[2];
        this.markers = this.markers.filter(item => {
          return item.d2_payaddr.includes(allAddress);
        });
      }

      if (this.mapRadioValue === `1`) {
        this.checkInCircle();
      } else {
        this.checkInRectangle();
      }
    },
    listFilter() {
      // 整合篩選過濾
      this.searchResult = [...this.originResult];
      // 過濾客戶姓名  clientName
      if (this.inteSelect.clientName !== "") {
        this.searchResult = this.searchResult.filter(item => {
          return item.ceapcnm.includes(this.inteSelect.clientName);
        });
      }
      // 過濾收費人員  charger
      if (
        this.inteSelect.charger[0] !== "" &&
        this.inteSelect.charger[1] !== ""
      ) {
        if (this.inteSelect.charger[0] == "now") {
          // 過濾現行人員
          this.searchResult = this.searchResult.filter(item => {
            return item.ceclcnm.includes(this.inteSelect.charger[1]);
          });
        }
        if (this.inteSelect.charger[0] == "past") {
          // 過濾前一人員
          this.searchResult = this.searchResult.filter(item => {
            if (item.ceclcnm_old) {
              return item.ceclcnm_old.includes(this.inteSelect.charger[1]);
            }
          });
        }
      }
      // 過濾VIP  vip
      if (this.inteSelect.vip !== "") {
        this.searchResult = this.searchResult.filter(item => {
          return item.idmark.includes(this.inteSelect.vip);
        });
      }
      // 過濾自招  ceagent
      if (this.inteSelect.self !== "") {
        this.searchResult = this.searchResult.filter(item => {
          return item.ceagent.includes(this.inteSelect.self);
        });
      }
      // 過濾整合地址  address
      if (this.inteSelect.address[0] !== "") {
        let allAddress =
          this.inteSelect.address[0] + this.inteSelect.address[1];
        this.searchResult = this.searchResult.filter(item => {
          return item.d2_payaddr.includes(allAddress);
        });
      }

      if (this.inteSelect.address[2] !== "") {
        let allAddress = this.inteSelect.address[2];
        this.searchResult = this.searchResult.filter(item => {
          return item.d2_payaddr.includes(allAddress);
        });
      }

      // 難字 update
      let copyAry = [...this.searchResult];
      this.searchResult = [];
      this.resultSelection = [];
      setTimeout(() => {
        this.searchResult = copyAry;
        this.registerHanlink();
      }, 100);
    },
    initAllocationList() {
      const fromPath = this.fromPath
      if(fromPath.includes('smartMatching'))
        this.exercuteAllocationFromTab1SmartMatching()
      else
        this.exercuteAllocationTab1()
      
    },
    exercuteAllocationTab1(){
      this.condictions = this.RouterPara.managerTabOne.condictions;
      this.condictions.isResignType = this.$store.state.isResignType;
      this.condictions.resign_id = this.$store.state.resignInfo.resign_id;
      this.queryAllocationList(this.condictions);
      this.cityList = [...this.Cities];
      setTimeout(() => {
        this.registerHanlink(); //難字 update
      }, 50);
    },
    exercuteAllocationFromTab1SmartMatching(){
      const datas = this.RouterPara.smartMatching.datas;
      const type  = this.RouterPara.smartMatching.type;
      this.queryAllocationList(this.condictions);
      this.cityList = [...this.Cities];
      setTimeout(() => {
        this.registerHanlink(); //難字 update
      }, 50);
    },
    returnIndex() {
      this.panelClose("warnModalOpen");
      let roleId = this.$store.state.userInfo.roleId || "";
      if (roleId == "SALES_MANAGER_02" || roleId == "SALES_MANAGER_06") {
        //  如果是大主管
        this.$router.push({ name: "transfer-tab1" });
      } else {
        //  如果是小主管
        this.$router.push({ name: "sub-transfer-tab-1" });
      }
    },
    queryAllocationList(condictions) {
      //呼叫服務件列表API
      this.listLoading = true;
      queryAllocationList(this.$store.state.userInfo.id, condictions).then(
        result => {
          if (result && result.header && "200" === result.header.status) {
            this.listLoading = false;
            if (result.body && result.body.policy_list) {
              this.inAgentInfo = result.body.inag_info;
              this.originResult = result.body.policy_list;
              console.log("result.body.policy_list", result.body.policy_list);
              this.originResult.forEach(data => {
                if (data.cenxpdt === "1911-01-01") {
                  // 判別日期
                  data.cenxpdt = "";
                }
                if (data.idmark) {
                  if (data.idmark.includes("G")) {
                    // 判別VIP 黃金
                    data.vip = 5;
                  } else if (data.idmark.includes("P")) {
                    // 判別VIP 白金
                    data.vip = 6;
                  } else if (data.idmark.includes("D")) {
                    // 判別VIP 鑽石
                    data.vip = 7;
                  }
                } else {
                  data.idmark = "";
                  data.vip = 0;
                }
              });
              this.searchResult = [...this.originResult]; // 拷貝一份當參考
              if (this.RouterPara.managerTabOne.condictions.type == "6") {
                this.originalCount = result.body.limit.count; // 記錄原始單日上限
              }

              // 針對地址查詢 超過4000件保單 返回首頁
              if (
                result.body.rows != "" &&
                Number(result.body.rows) > 4000 &&
                condictions.type == "4"
              ) {
                this.warnModalMsg =
                  "此條件查詢到超過4000件保單，請輸入詳細地址可以更容易找到您所要分配的服務件!";
                this.warnMethodName = "returnIndex";
                this.warnCancelShow = false;
                this.panelOpen("warnModalOpen");
              }

              // 預設勾選
              this.searchResult.forEach((e, index) => {
                if (e.resign_agent == "1" && !e.mgr_id) {
                  this.resultSelection.push(index);
                }
              });
            }
          } else {
            this.$toast.info({ title: result.header.message });
            this.searchResult = [];
          }
          this.registerHanlink(); // 難字 update
        }
      );
    },
    processSearchResult(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      this.listLoading = true;
      setTimeout(() => {
        this.searchResult.sort(this.sortCompareFun(sortOrder, fieldName));
        this.listLoading = false;
        this.registerHanlink(); // 難字顯示
      }, 20);
    },
    sortCompareFun(sortOrder, property) {
      if (property === `ceclcnm_old` || `ceagnnm` || `other_ceclcnm`) {
        return function(a, b) {
          let a_value = a[property] ? a[property] : "";
          let b_value = b[property] ? b[property] : "";
          let result = a_value < b_value ? -1 : a_value > b_value ? 1 : 0;
          return result * sortOrder;
        };
      } else if (property === "cenxpdt" || property === "deadline") {
        let cVue = this;
        return function(a, b) {
          var a_value =
            cVue.$options.filters.dateFormat(a[property]) != `— —`
              ? a[property]
              : ``;
          var b_value =
            cVue.$options.filters.dateFormat(b[property]) != `— —`
              ? b[property]
              : ``;

          let result = a_value < b_value ? -1 : a_value > b_value ? 1 : 0;
          return result * sortOrder;
        };
      } else {
        return function(a, b) {
          let result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }
    },
    radiusChanged(value) {
      // 圓形大小改變
      this.radius = value;
      this.checkInCircle();
    },
    center_changed(value) {
      this.circleCenter.lat = value.lat();
      this.circleCenter.lng = value.lng();
      this.checkInCircle();
    },
    rectangleChanged(value) {
      // 更新方形大小座標.
      if (value.Ya) {
        this.rectangle = new google.maps.Polygon({
          paths: [
            { lat: value.Ya.i, lng: value.Ua.i },
            { lat: value.Ya.j, lng: value.Ua.i },
            { lat: value.Ya.j, lng: value.Ua.j },
            { lat: value.Ya.i, lng: value.Ua.j }
          ]
        });
      } else if (value.Za) {
        this.rectangle = new google.maps.Polygon({
          paths: [
            { lat: value.Za.i, lng: value.Ua.i },
            { lat: value.Za.j, lng: value.Ua.i },
            { lat: value.Za.j, lng: value.Ua.j },
            { lat: value.Za.i, lng: value.Ua.j }
          ]
        });
      }
      this.rectangleValue = value;
      this.checkInRectangle();
    },
    updateMapCenter(value) {
      // 地圖中心點改變
      this.mapCenter.lat = value.lat();
      this.mapCenter.lng = value.lng();

      if (this.mapRadioValue === `1`) {
        this.circleCenter.lat = value.lat();
        this.circleCenter.lng = value.lng();
        this.checkInCircle();
      } else if (this.mapRadioValue === `2`) {
        if (!this.rectangleValue) {
          // 當undefined則使用預設zoomFactor範圍
          this.rectangleBounds = {
            north: this.mapCenter.lat + this.zoomFactor,
            south: this.mapCenter.lat - this.zoomFactor,
            east: this.mapCenter.lng + this.zoomFactor,
            west: this.mapCenter.lng - this.zoomFactor
          };
        } else {
          // 使用者已有更改方形範圍
          if (this.rectangleValue.Ya) {
            this.rectangleBounds = {
              north:
                this.mapCenter.lat -
                (this.rectangleValue.Ya.i - this.rectangleValue.Ya.j) / 2,
              south:
                this.mapCenter.lat +
                (this.rectangleValue.Ya.i - this.rectangleValue.Ya.j) / 2,
              east:
                this.mapCenter.lng -
                (this.rectangleValue.Ua.i - this.rectangleValue.Ua.j) / 2,
              west:
                this.mapCenter.lng +
                (this.rectangleValue.Ua.i - this.rectangleValue.Ua.j) / 2
            };
          } else if (this.rectangleValue.Za) {
            this.rectangleBounds = {
              north:
                this.mapCenter.lat -
                (this.rectangleValue.Za.i - this.rectangleValue.Za.j) / 2,
              south:
                this.mapCenter.lat +
                (this.rectangleValue.Za.i - this.rectangleValue.Za.j) / 2,
              east:
                this.mapCenter.lng -
                (this.rectangleValue.Ua.i - this.rectangleValue.Ua.j) / 2,
              west:
                this.mapCenter.lng +
                (this.rectangleValue.Ua.i - this.rectangleValue.Ua.j) / 2
            };
          }
        }
        this.checkInRectangle();
      }
    },
    dragend() {
      // 拖動結束 再檢查一次
      this.checkIn();
    },
    checkInCircle() {
      // 檢查圓形範圍內座標
      var cicrcle = new google.maps.Circle({
        center: {
          lat: this.circleCenter.lat,
          lng: this.circleCenter.lng
        },
        radius: this.radius
      });

      this.selectedMarker = [];
      this.markers.forEach(m => {
        var _kCord = new google.maps.LatLng(m.position.lat, m.position.lng);
        var distance = google.maps.geometry.spherical.computeDistanceBetween(
          _kCord,
          cicrcle.getCenter()
        );
        if (this.radius >= distance) {
          this.selectedMarker.push(m);
        }
      });
    },
    checkInRectangle() {
      // 檢查方形範圍內座標
      this.selectedMarker = [];
      this.markers.forEach(m => {
        var _kCord = new google.maps.LatLng(m.position.lat, m.position.lng);
        if (
          google.maps.geometry.poly.containsLocation(_kCord, this.rectangle)
        ) {
          this.selectedMarker.push(m);
        }
      });
    },
    checkIn() {
      if (this.mapRadioValue === `1`) {
        this.checkInCircle();
      } else {
        this.checkInRectangle();
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPath = from.path
    })
  },
  mounted() {
    this.initAllocationList();
  }
};
</script>
